import React from 'react';

export const LogoIcon = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px' }}>
      <img
        src="/marketcast-icon.png"
        alt="MarketHub"
        style={{ width: '28px', height: '28px', objectFit: 'contain' }}
      />
    </div>
  );
};
